"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectMultiple = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var dropdown_1 = require("../dropdown");
var checkbox_1 = require("../checkbox");
var form_1 = require("../form");
var checktree_1 = require("../checktree");
var button_1 = require("../button");
var text_1 = require("../text");
var i18n_1 = require("../i18n");
var config_context_1 = require("../_util/config-context");
var tips_1 = require("../tips");
var searchbox_1 = require("../searchbox");
var inject_value_1 = require("../_util/inject-value");
var tooltip_1 = require("../tooltip");
var use_default_1 = require("../_util/use-default");
var noop_1 = require("../_util/noop");
var search_filter_1 = require("../_util/search-filter");
var forward_ref_with_statics_1 = require("../_util/forward-ref-with-statics");
var is_mobile_1 = require("../_util/is-mobile");
var use_unmounted_1 = require("../_util/use-unmounted");
var util_1 = require("./util");
var VirtualizedList_1 = require("../list/VirtualizedList");
exports.SelectMultiple = forward_ref_with_statics_1.forwardRefWithStatics(function SelectMultiple(props, ref) {
    var e_1, _a;
    var t = i18n_1.useTranslation();
    var classPrefix = config_context_1.useConfig().classPrefix;
    var _b = form_1.useDefaultValue(props, []), _c = _b.staging, staging = _c === void 0 ? true : _c, value = _b.value, onChange = _b.onChange, _d = _b.options, options = _d === void 0 ? [] : _d, groups = _b.groups, allOption = _b.allOption, _e = _b.shouldOptionExcludeFromAll, shouldOptionExcludeFromAll = _e === void 0 ? "disabled" : _e, _f = _b.allowEmpty, allowEmpty = _f === void 0 ? true : _f, _g = _b.onOpen, onOpen = _g === void 0 ? noop_1.noop : _g, _h = _b.onClose, onClose = _h === void 0 ? noop_1.noop : _h, searchable = _b.searchable, _j = _b.searchPlaceholder, searchPlaceholder = _j === void 0 ? "" : _j, _k = _b.onSearch, onSearch = _k === void 0 ? noop_1.noop : _k, customizeFilter = _b.filter, filterRender = _b.filterRender, _l = _b.autoClearSearchValue, autoClearSearchValue = _l === void 0 ? true : _l, _m = _b.defaultSearchValue, defaultSearchValue = _m === void 0 ? "" : _m, searchValue = _b.searchValue, onSearchValueChange = _b.onSearchValueChange, clearable = _b.clearable, _o = _b.onScrollBottom, onScrollBottom = _o === void 0 ? noop_1.noop : _o, bottomTips = _b.bottomTips, footer = _b.footer, _p = _b.virtual, virtual = _p === void 0 ? false : _p, listWidth = _b.listWidth, listHeight = _b.listHeight, _q = _b.boxStyle, boxStyle = _q === void 0 ? {} : _q, onReset = _b.onReset, _r = _b.onStagingValueChange, onStagingValueChange = _r === void 0 ? noop_1.noop : _r, onlySubmitFilterFromAll = _b.onlySubmitFilterFromAll, dropdownProps = tslib_1.__rest(_b, ["staging", "value", "onChange", "options", "groups", "allOption", "shouldOptionExcludeFromAll", "allowEmpty", "onOpen", "onClose", "searchable", "searchPlaceholder", "onSearch", "filter", "filterRender", "autoClearSearchValue", "defaultSearchValue", "searchValue", "onSearchValueChange", "clearable", "onScrollBottom", "bottomTips", "footer", "virtual", "listWidth", "listHeight", "boxStyle", "onReset", "onStagingValueChange", "onlySubmitFilterFromAll"]);
    // 移动端 focus 可能产生滚动导致关闭
    if (is_mobile_1.isMobile && searchable) {
        dropdownProps.closeOnScroll = false;
    }
    var vListRef = react_1.useRef(null);
    var _s = tslib_1.__read(react_1.useState(value), 2), stagingValue = _s[0], setStagingValue = _s[1];
    var InputRef = react_1.useRef(null);
    var _t = tslib_1.__read(use_default_1.useDefault(searchValue, defaultSearchValue, onSearchValueChange), 2), inputValue = _t[0], setInputValue = _t[1];
    var unmountedRef = use_unmounted_1.useUnmounted();
    var filter = customizeFilter ||
        (function (inputValue, _a) {
            var text = _a.text, value = _a.value;
            var optionText = String(typeof text === "string" ? text : value);
            return !searchable || search_filter_1.searchFilter(optionText, inputValue);
        });
    var hasGroup = !!options.find(function (opt) { return !!opt.groupKey; });
    function focus() {
        if (!is_mobile_1.isMobile && searchable) {
            setTimeout(function () {
                if (InputRef.current) {
                    InputRef.current.focus();
                }
            }, 100); // 第一次展开时 Input 还未渲染
        }
    }
    var handleChange = function (value, context) {
        if (staging === false) {
            onChange(value, context);
            return;
        }
        setStagingValue(value);
        onStagingValueChange(value);
    };
    // 「全部」选项和其余选项是数关系
    var relations = {};
    var excludeFromAll = [];
    if (allOption) {
        try {
            for (var options_1 = tslib_1.__values(options), options_1_1 = options_1.next(); !options_1_1.done; options_1_1 = options_1.next()) {
                var option = options_1_1.value;
                if (
                // 用户可以指定哪些选项从全选逻辑中排除
                (typeof shouldOptionExcludeFromAll === "function" &&
                    shouldOptionExcludeFromAll(option)) ||
                    (shouldOptionExcludeFromAll === "disabled" && option.disabled)) {
                    excludeFromAll.push(option.value);
                    // continue
                }
                else {
                    relations[option.value] = allOption.value;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (options_1_1 && !options_1_1.done && (_a = options_1.return)) _a.call(options_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    // 筛选
    var filteredOptions = options.filter(function (options) {
        return filter(inputValue, options);
    });
    var tips = props.tips;
    if (!tips && filteredOptions.length === 0) {
        tips = react_1.default.createElement(tips_1.EmptyTip, null);
    }
    var items = util_1.getListItems({
        tips: tips ? inject_value_1.injectValue(tips)(filteredOptions) : null,
        bottomTips: inject_value_1.injectValue(bottomTips)(filteredOptions),
        groups: groups,
        options: filteredOptions,
        allOption: allOption,
    }).map(function (item) {
        if (item.type === "option" && searchable && filterRender) {
            return tslib_1.__assign(tslib_1.__assign({}, item), { text: filterRender(inputValue, item.option) });
        }
        return item;
    });
    if (listWidth) {
        boxStyle.width = listWidth;
        boxStyle.minWidth = listWidth;
    }
    // 重置数据
    var resetData = function (context) {
        if (inputValue !== "") {
            setInputValue("", context);
        }
        var defaultData = [];
        if (onReset && typeof onReset === "function") {
            var originResetData = onReset(context);
            // 非受控模式，在reset的时候 可以处置数据
            if (originResetData) {
                defaultData = Array.isArray(originResetData)
                    ? originResetData
                    : defaultData;
            }
            else {
                // 受控场景无需走内置场景
                return;
            }
        }
        handleChange(defaultData, context);
    };
    return (react_1.default.createElement(dropdown_1.Dropdown, tslib_1.__assign({ ref: ref }, dropdownProps, { preventMouseDown: !searchable && !footer, updateOnChildrenChange: true, button: react_1.default.createElement(ValueBrief, tslib_1.__assign({}, props, { value: value })), onOpen: function () {
            setStagingValue(value);
            onStagingValueChange(value);
            focus();
            onOpen();
        }, onClose: function () {
            if (autoClearSearchValue && inputValue !== "") {
                setTimeout(function () {
                    if (!unmountedRef.current) {
                        setInputValue("", {});
                    }
                }, 300);
            }
            onClose();
        }, clickClose: false, clearable: value.length && clearable, boxStyle: boxStyle, onClear: function (event) {
            onChange([], { event: event });
            setStagingValue([]);
            onStagingValueChange([]);
        } }), function (close) { return (react_1.default.createElement(checktree_1.CheckTree, { relations: relations, value: (staging ? stagingValue : value) || value, onChange: handleChange, disabledNames: options.filter(function (x) { return x.disabled; }).map(function (x) { return x.value; }) },
        searchable && (react_1.default.createElement(searchbox_1.SearchBox, { simple: true, ref: InputRef, value: inputValue, onChange: function (value, context) {
                setInputValue(value, context);
                onSearch(value, context);
            }, onClear: focus, placeholder: searchPlaceholder, onSearch: onSearch })),
        react_1.default.createElement(VirtualizedList_1.VirtualizedList, { virtual: virtual, containerStyle: boxStyle, className: classPrefix + "-list--checkoption", containerClassName: dropdownProps.boxClassName, items: items.map(function (item) {
                if (item.type === "option") {
                    var option = item.option;
                    var content = option.text || option.value;
                    return tslib_1.__assign(tslib_1.__assign({}, item), { text: (react_1.default.createElement(checkbox_1.Checkbox, { onClick: function (evt) { return evt.stopPropagation(); }, name: option.value, title: !option.tooltip && typeof content === "string"
                                ? content
                                : undefined }, content)), props: {
                            disabled: option.disabled,
                            tooltip: option.tooltip,
                        } });
                }
                return item;
            }), virtualizedRef: vListRef, type: hasGroup ? "option-group" : "option", onScrollBottom: onScrollBottom, listHeight: listHeight }),
        (footer || staging !== false) && (react_1.default.createElement(dropdown_1.Dropdown.Footer, null,
            footer,
            staging !== false && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(button_1.Button, { type: "primary", htmlType: "button", disabled: !allowEmpty && stagingValue.length === 0, onClick: function (event) {
                        event.stopPropagation();
                        onChange(stagingValue.filter(function (v) {
                            return !onlySubmitFilterFromAll ||
                                !excludeFromAll.includes(v);
                        }), { event: event });
                        close();
                    } }, t.okText),
                react_1.default.createElement(button_1.Button, { type: "weak", htmlType: "button", onClick: function (event) {
                        event.stopPropagation();
                        resetData({ event: event });
                    } }, t.resetText))))))); }));
}, {
    defaultLabelAlign: "middle",
});
exports.SelectMultiple.displayName = "SelectMultiple";
function ValueBrief(props) {
    var t = i18n_1.useTranslation();
    var value = props.value, allOption = props.allOption, options = props.options, button = props.button, _a = props.placeholder, placeholder = _a === void 0 ? t.pleaseSelect : _a, _b = props.appearance, appearance = _b === void 0 ? props.appearence : _b;
    var buttonPlaceholder = placeholder;
    if (!appearance || appearance === "button" || appearance === "default") {
        buttonPlaceholder = react_1.default.createElement(text_1.Text, { theme: "weak" }, placeholder);
    }
    var _c = tslib_1.__read(react_1.useState((value || []).map(function (x) { return options.find(function (y) { return y.value === x; }) || { value: x }; })), 2), selectedOptions = _c[0], setSelectedOptions = _c[1];
    react_1.useEffect(function () {
        setSelectedOptions(function (selectedOptions) {
            return (value || [])
                .map(function (v) {
                return options.find(function (option) { return option.value === v; }) ||
                    selectedOptions.find(function (option) { return option.value === v; });
            })
                .filter(Boolean);
        });
    }, [options, value]);
    if (button) {
        return react_1.default.createElement("div", null, inject_value_1.injectValue(button)(selectedOptions));
    }
    if (!value || !value.length) {
        return react_1.default.createElement(react_1.default.Fragment, null, buttonPlaceholder);
    }
    if (allOption &&
        value.length === options.length &&
        value.filter(function (v) { return options.find(function (o) { return o.value === v; }); }).length ===
            options.length) {
        return react_1.default.createElement("span", null, allOption.text || allOption.value);
    }
    var exceed = selectedOptions.length > 5;
    return (react_1.default.createElement(tooltip_1.Tooltip, { title: selectedOptions.map(function (o, index) { return (react_1.default.createElement(react_1.Fragment, { key: o.value },
            o.text || o.value,
            index < selectedOptions.length - 1 && ", ")); }) },
        react_1.default.createElement(text_1.Text, { overflow: true },
            selectedOptions.slice(0, 5).map(function (o, index) { return (react_1.default.createElement("span", { key: o.value },
                o.text || o.value,
                index < selectedOptions.length - 1 && ", ")); }),
            exceed && react_1.default.createElement("span", null, "..."))));
}
ValueBrief.displayName = "SelectValueBrief";
//# sourceMappingURL=SelectMultiple.js.map